<template>
	<template v-if="content.content?.button_link.cached_url">
		<nuxt-link :to="'/' + content.content?.button_link.cached_url">
			<div
				class="grid grid-cols-8 justify-start rounded bg-(--background-color) p-md text-(--font-color)"
				:style="{
					'--background-color': backgroundColor,
					'--font-color': fontColor,
				}"
			>
				<div class="col-span-5 col-start-1 lg:col-span-4 lg:col-start-3">
					<p
						class="text-start font-prenton-cond leading-6 font-bold tracking-3xl uppercase lg:text-center lg:text-xl"
					>
						{{ content.content?.description }}
					</p>
				</div>

				<div
					class="col-span-2 col-start-7 flex flex-row items-center md:mt-0 lg:col-start-8"
				>
					<p
						class="mr-2 font-prenton-cond leading-6 tracking-3xl uppercase md:text-base lg:text-xl"
					>
						{{ content.content?.button_text }}
					</p>

					<v-icon icon="arrow-right" class="size-[24px] md:size-[24px]" />
				</div>
			</div>
		</nuxt-link>
	</template>

	<template v-else>
		<div
			class="justify-start rounded bg-(--background-color) p-md text-(--font-color) md:flex md:flex-row lg:justify-center"
			:style="{
				'--background-color': backgroundColor,
				'--font-color': fontColor,
			}"
		>
			<div>
				<p
					class="font-prenton-cond leading-6 font-bold uppercase lg:text-center lg:text-xl"
				>
					{{ content.content?.description }}
				</p>
			</div>
		</div>
	</template>
</template>

<script setup lang="ts">
import type {ISbStoryData} from "storyblok-js-client";

const properties = defineProps<{
	content: ISbStoryData;
}>();

const backgroundColor = computed<string | undefined>(
	() => properties.content?.content?.background_color?.color ?? "#EF1C35",
);

const fontColor = computed<string | undefined>(
	() => properties.content?.content?.text_color.color ?? "#FFF",
);
</script>
